import { FC } from 'react';

import { SvgIcon, SxProps } from '@thirdspacelearning/library';

interface Props {
    sx?: SxProps;
}

const LoStartedIcon: FC<Props> = ({ sx }) => {
    return (
        <SvgIcon
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            sx={sx}
            data-testid="learning-objective-started-icon"
        >
            <rect width="52" height="52" rx="26" fill="#BCE7FF" />
            <mask
                id="mask0_lo_started"
                style={{ maskType: 'alpha' }}
                maskUnits="userSpaceOnUse"
                x="6"
                y="6"
                width="39"
                height="39"
            >
                <rect x="6" y="6" width="39" height="39" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_lo_started)">
                <path
                    d="M19.1623 40.4704C17.1852 39.6173 15.4655 38.4595 14.003 36.997C12.5405 35.5345 11.3826 33.8147 10.5295 31.8376C9.67639 29.8605 9.24983 27.748 9.24983 25.5001C9.24983 23.2522 9.67639 21.1397 10.5295 19.1626C11.3826 17.1855 12.5405 15.4657 14.003 14.0032C15.4655 12.5407 17.1852 11.3829 19.1623 10.5298C21.1394 9.67668 23.2519 9.25012 25.4998 9.25012C27.7477 9.25012 29.8603 9.67668 31.8373 10.5298C33.8144 11.3829 35.5342 12.5407 36.9967 14.0032C38.4592 15.4657 39.617 17.1855 40.4701 19.1626C41.3233 21.1397 41.7498 23.2522 41.7498 25.5001C41.7498 27.748 41.3233 29.8605 40.4701 31.8376C39.617 33.8147 38.4592 35.5345 36.9967 36.997C35.5342 38.4595 33.8144 39.6173 31.8373 40.4704C29.8603 41.3236 27.7477 41.7501 25.4998 41.7501C23.2519 41.7501 21.1394 41.3236 19.1623 40.4704ZM25.4998 38.5001C27.2332 38.5001 28.8988 38.1751 30.4967 37.5251C32.0946 36.8751 33.503 35.9407 34.7217 34.722L25.4998 25.5001V12.5001C21.8707 12.5001 18.7967 13.7595 16.278 16.2782C13.7592 18.797 12.4998 21.871 12.4998 25.5001C12.4998 29.1293 13.7592 32.2032 16.278 34.722C18.7967 37.2407 21.8707 38.5001 25.4998 38.5001Z"
                    fill="#05A5FF"
                />
            </g>
        </SvgIcon>
    );
};

export default LoStartedIcon;
